import { Pipe, PipeTransform } from '@angular/core';
import { formatEmail, emailParts } from '../utils/email.util';

/**
 * Renders a stored email value in canonical form.
 *
 * Existing rows are not being backfilled, so every display site has to format
 * on read: the column holds a mix of single addresses and older values pasted
 * in with semicolons or ragged spacing.
 */
@Pipe({ name: 'email' })
export class EmailPipe implements PipeTransform {
  transform(value: string): string {
    return formatEmail(value);
  }
}

/**
 * The individual addresses behind a value, for building one mailto: link per
 * address. A mailto: URI carrying a comma separated list opens a compose window
 * addressed to a single malformed recipient in most clients.
 */
@Pipe({ name: 'emailList' })
export class EmailListPipe implements PipeTransform {
  transform(value: string): string[] {
    return emailParts(value);
  }
}
